import React from "react";
import "../css/maintenance.css";

const MaintenancePage = () => {
  return (
    <main className="maintenance-page">
      <div className="maintenance-shell">
        <p className="maintenance-eyebrow">Site Notice</p>
        <h1>The website is temporarily taken down by the owner.</h1>
        <p className="maintenance-copy">
          Thanks for stopping by. The site is currently unavailable while
          updates are being made. Please check back again soon.
        </p>
        <div className="maintenance-meta">
          <div className="maintenance-card">
            <span className="maintenance-label">Status</span>
            <strong>Offline for maintenance</strong>
          </div>
          <div className="maintenance-card">
            <span className="maintenance-label">Back soon</span>
            <strong>Under active review</strong>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MaintenancePage;
